import { render } from "./profile-gallery.svg?vue&type=template&id=18c7c1f6"
const script = {}
script.render = render

export default script